import { Component, HostListener, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ApiService, CommonFunctionsService, DatastoreService } from 'src/app/services';
import { NgModule } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { settings } from 'cluster';
import { IPageInfo, VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { Buffer } from 'buffer';


@Component({
  selector: 'app-arrival-status',
  templateUrl: './arrival-status.component.html',
  styleUrls: ['./arrival-status.component.scss']
})
export class ArrivalStatusComponent implements OnInit {

  @ViewChild(VirtualScrollerComponent) virtualScroller!: VirtualScrollerComponent;

  exampleConfig = {
    "me": "bookinglab-demo:37159", "company": 37159, "companyName": "BOOKINGLAB", "sso": false, "requireLogin": true, "staging": true, "favicon": "", "favicon_link": "https://www.bristol.gov.uk/templates/bcc/assets/favicons/favicon.ico", "footer_colour": "#161B40", "header_colour": "#161B40", "host": "https://bookinglab-demo.bookingbug.com", "logo": "https://www.bristol.gov.uk/images/General/Logos/BCC-logo-spot-white-text-dots.png", "logo_link": "https://www.bristol.gov.uk/", "header_text": "bristol.gov.uk", "page_title": "bristol Customer Check-in", "text_colour": "#FFF", "terms": "COMMON.SUMMARY_PAGE.TERMS", "kiosk_options": { "use_queue": false, "use_websocket": true }, "searchFields": { "service": { "48694": { "id": "126" }, "48695": { "id": "126" }, "48696": { "id": "126" } } }, "cache": { "cache_find_button": true }, "checkinTypes": { "QRcode": true, "reference": true, "info": true }, "infoQuestions": { "lastName": true, "dob": true, "postcode": false }, "dobQuestion": 163, "service": 48775, "addressApi": "iVJz2hNwTXjtg1SgcLlHCebAMiVLRQaE", "addressEnabled": true, "customizable":
    {
      "confirmed": {
        "show": true,
        "buttons": { "arrived": true, "noShow": true, "notes": true },
        "tabs": [
          { "heading": "Name", "data": ["booking", "name"] },
          { "heading": "Company", "data": ["booking", "company_name"] },
          { "heading": "Time", "data": ["booking", "datetime"] },
          { "heading": "Registration", "data": ["booking", "questions", { "filterKey": "id", "filterValue": 280 }, "answer"] }
        ]
      },
      "arrived": {
        "show": true,
        "buttons": { "confirmed": true, "notes": true },
        "tabs": [
          { "heading": "Name", "data": ["booking", "name"] },
          { "heading": "Company", "data": ["booking", "company_name"] },
          { "heading": "Time", "data": ["booking", "datetime"] },
          { "heading": "Registration", "data": ["booking", "questions", { "filterKey": "id", "filterValue": 280 }, "answer"] },
          { "heading": "Invoice ref", "data": ["booking", "invoice_ref"] }
        ]
      },
      "noShow": {
        "show": true,
        "buttons": { "confirmed": true, "notes": true },
        "tabs": [
          { "heading": "Name", "data": ["booking", "name"] },
          { "heading": "Company", "data": ["booking", "company_name"] },
          { "heading": "Time", "data": ["booking", "datetime"] },
          { "heading": "Registration", "data": ["booking", "questions", { "filterKey": "id", "filterValue": 280 }, "answer"] },
          { "heading": "Obfuscated id", "data": ["booking", "obfuscated_id"] }
        ]
      }
    }, "set": {
      "noBooking": {
        "show": true
      }
    }
  }
  bookings: any = []
  members: any = []
  config: any
  bookingDetails: any
  status: string = ""
  tableData: any
  loadedTable: boolean = false
  paramRout: string;
  noShowAllConfirmToggle: boolean = false;
  searchText = ""
  unfilteredBookings: any;
  params = `?start_date=${moment().format("YYYY-MM-DD")}&end_date=${moment().format("YYYY-MM-DD")}`
  userActivity: any;
  isInactive: boolean = false;
  wasteUnits: string = "litres"
  observed: any;
  companyId: number;
  bookingEditQuestions: any;
  fileData: any
  fileSelector: any;
  bookingFiles: any;
  schema: any;
  meta: any;
  fileError: boolean = false;
  readonlyQuestionsContents: any[] = [];
  preparedTableData: Array<{ name: string; value: string }> = [];

  constructor(
    private apiService: ApiService,
    private commonFunctionsService: CommonFunctionsService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private dataStore: DatastoreService,
    private spinner: NgxSpinnerService,

  ) { }

  ngOnInit(): void {
    this.startup()
    this.prepareTableData();
  }

  
  prepareTableData() {
    this.preparedTableData = this.readonlyQuestionsContents.map(content => ({
      name: content.name,
      value: this.getDataForTable(this.bookingDetails, content)
    }));
  }

  // if user does anything, reset inactivity
  @HostListener('window:click') refreshUserStateClick() {
    this.resetInactivity()
  }
  @HostListener('window:mousemove') refreshUserStateMove() {
    this.resetInactivity()
  }
  @HostListener('window:keydown') refreshUserStateKey() {
    this.resetInactivity()
  }
  @HostListener('window:wheel') refreshUserStateScroll() {
    this.resetInactivity()
  }

  resetInactivity() {
    this.isInactive = false;
    clearTimeout(this.userActivity);
    this.setTimeout();
  }



  setTimeout() {
    this.userActivity = setTimeout(() => this.isInactive = true, 3000);
  }

  async startup() {
    const params: any = this.route.snapshot.params
    this.dataStore.company = params.comp
    this.paramRout = `/${params.site}/${params.comp}`
    this.params = params
    await this.getConfig()
    console.log("config", this.config)
    let authToken = localStorage.getItem('auth_token');
    let memberObject = localStorage.getItem('loginObject');
    if (authToken === "undefined" || !memberObject) {
      this.router.navigate([`/${params.site}/${params.comp}/login`])
      return
    }
    if (this.config.wasteLimits?.wasteUnits) {
      this.wasteUnits = this.config.wasteLimits.wasteUnits
    }
    if (this.config.hideAnswers === undefined) {
      this.config.hideAnswers = {}
    }
    this.status = "confirmed"
    this.tableData = this.config.ceremony_officer_app.customizable[this.status]
    console.log("this.tableData ", this.tableData)
    // const bookings = await this.getBookings();
    // this.members = await this.getMembers(bookings);
    // this.bookings = await this.makeDetailsArray(bookings);
    console.log(this.config)
    if (this.config.ceremony_officer_app.set.hasOwnProperty("observeReason")) {
      if (this.config.ceremony_officer_app.set.observeReason.show) {
        let observed: any = null
        try {
          observed = await this.apiService.getObserved(this.config)
        } catch (err) {
          console.log(err)
        }
        this.observed = observed
      }
    }
    if (this.dataStore.refresher) {
      clearInterval(this.dataStore.refresher)
    }
    this.dataStore.refresher = setInterval(() => {
      if (this.dataStore.refreshTimer > 60 * 15 && this.isInactive) {
        this.dataStore.refreshTimer = 0
        this.refresh(true)
        this.dataStore.refreshTimer = 0
      }
    }, 1000);

    this.loadedTable = true;
    setTimeout(() => {
      console.log(this.virtualScroller);

    }, 1);

  }

  async getConfig() {
    this.config = await this.commonFunctionsService.setCompanyName(this.params)
    this.companyId = parseInt(this.config.company);
    // let requireLogn = config.requireLogin;
    // if (!(requireLogn)) {
    //   this.router.navigate(['/access'])
    // }
    // if (config.hasOwnProperty('sso') && config.sso) {
    //   this.sso = true;
    // }
  }

  async refresh(reload = true) {
    // const bookings = await this.getBookings(reload)
    // await this.getMembers(bookings, reload)
    // this.bookings = await this.makeDetailsArray(bookings, reload)
    // this.dataStore.refreshTimer = 0;
  }

  async getMembers(bookings: any, refresh = false) {
    // bookings = this.dataStore.bookings
    console.log("getMembers", bookings)
    const foundMembers: any = [];
    if (bookings.length > 0) {
      let member_ids = [];
      for (const booking of bookings) {
        if (booking.client_id) {
          member_ids.push(booking.client_id);
        }
        if (member_ids.length > 1000) { // max number of shards in an elastic search is 1200
          const clients: any = await this.apiService.fetchBookingClients(this.config.company, member_ids);
          if (clients.hits.total > 0) {
            for (const clientTmp of clients.hits.hits) {
              const client = clientTmp._source;
              foundMembers.push(client);
            }
          }
          member_ids = []
        }
      }

      if (member_ids.length > 0) {
        const clients: any = await this.apiService.fetchBookingClients(this.config.company, member_ids);
        if (clients.hits.total > 0) {
          for (const clientTmp of clients.hits.hits) {
            const client = clientTmp._source;
            foundMembers.push(client);
          }
        }
      }
      this.dataStore.members = foundMembers
      return foundMembers;
    }
  }

  statusConverter(status: string) {
    status = status === "confirmed" ? "" : status
    status = status === "noShow" ? "No show" : status
    status = status === "rejected" ? "Rejected" : status
    status = status === "arrived_and_paid" ? "arrived_and_paid" : status
    status = status === "arrived" ? "Checked in" : status
    return status
  }



  async makeDetailsArray(bookings: any, refresh = false) {
    // console.log(bookings)
    const detailArray: any = []
    this.unfilteredBookings = []
    this.fileData = undefined
    this.fileSelector = undefined
    let services: any = {}

    if (this.dataStore.services) {
      services = this.dataStore.services
    }
    const members: any = {}

    // where stopping the entire operation
    if (bookings.filter((x: { service_id: undefined; }) => x.service_id === undefined).length > 0) {
      console.log("the following bookings have no service set")
      console.log(bookings.filter((x: { service_id: undefined; }) => x.service_id === undefined))
      bookings = bookings.filter((x: { service_id: undefined; }) => x.service_id !== undefined)
    }

    for (let booking of bookings) {
      let note = ""
      if (booking?.settings?.private_notes) {
        if (booking?.settings?.private_notes[0]) {
          note = booking.settings.private_notes[0]
        }
      }

      let service: any = null;
      if (services[booking.service_id]) {
        service = services[booking.service_id]
      } else {
        service = await this.apiService.getService(booking.company_id, booking.service_id)
        service.bookingQuestions = await this.apiService.questions(service);
        service.bookingQuestions = service.bookingQuestions.questions
        services[booking.service_id] = service
      }
      this.dataStore.services = services;

      // let limits: any = this.dataStore.limits[booking.id]

      const bookingQuestionsForm: FormGroup = this.formBuilder.group({});
      for (let index = 0; index < service.bookingQuestions.length; index++) {
        const question = service.bookingQuestions[index];
        if (this.inModifiableQuestionsList(question.id)) {

          question.visible = false;
          question.reference = question.id;

          let showAdmin = false;
          if (this.config.showAdminQuestions) {
            // make admin questions show all the time
            showAdmin = true;
          } else {
            // config says dont show admin Q
            if (question.admin_only) {
              // question is admin only, dont show it
              showAdmin = false;
            } else {
              // question isnt admin, show it
              showAdmin = true;
            }
          }

          if (showAdmin) {
            if (!question.settings.hasOwnProperty("conditional_question")) {
              question.visible = true;
            }
            const questionControl = question.id;

            if (question.detail_type == 'check' || question.detail_type == 'check-price') {
              if (question.required) {
                bookingQuestionsForm.addControl(questionControl, new FormControl(false, Validators.requiredTrue));
              } else {
                bookingQuestionsForm.addControl(questionControl, new FormControl(false));
              }
            } else {
              if (question.required) {
                bookingQuestionsForm.addControl(questionControl, new FormControl('', Validators.required));
              } else {
                bookingQuestionsForm.addControl(questionControl, new FormControl(''));
              }
            }
          }
        }
      }

      for (let answer of booking.answers_summary) {
        if (answer.answer === "false") {
          answer.answer = false
        }
        if (bookingQuestionsForm.controls[answer.question_id]) {
          bookingQuestionsForm.controls[answer.question_id].setValue(answer.answer)
        }
      }
      for (let answer of booking.survey_answers_summary) {
        if (answer.answer === "false") {
          answer.answer = false
        }
        if (bookingQuestionsForm.controls[answer.question_id]) {
          bookingQuestionsForm.controls[answer.question_id].setValue(answer.answer)
        }
      }
      let option = ""
      if (this.showNotesDropdown()) {
        if (booking.questions[this.config.ceremony_officer_app.notesDropDown.adminBookingQuestionID]) {
          option = booking.questions[this.config.ceremony_officer_app.set.notesDropDown.adminBookingQuestionID].answer
        }
      }
      const member = await this.apiService.getClient(this.config.company, booking.client_id)

      const bookingDetails = {
        booking: booking,
        service: service,
        member: member,
        // limits: limits,
        settings: booking.settings,
        note: note,
        option: option,
        amendQuestionsShow: false,
        bookingQuestionsForm: bookingQuestionsForm,
        submitted: false
      }
      this.onQuestionChange(bookingQuestionsForm, bookingDetails)
      detailArray.push(bookingDetails)
      this.unfilteredBookings.push(bookingDetails)
    }
    console.log(detailArray)

    return detailArray
  }

  sortByRegistration(arr: any) {
    return arr.sort((
      a: {
        answers_summary: any;
      }, b: {
        answers_summary: any;
      }) => {
      if (a.answers_summary.find((x: { name: string; }) => x.name.toLocaleLowerCase().includes("vehicle reg")) && b.answers_summary.find((x: { name: string; }) => x.name.toLocaleLowerCase().includes("vehicle reg"))?.answer) {
        return a.answers_summary.find((x: { name: string; }) => x.name.toLocaleLowerCase().includes("vehicle reg"))?.answer.localeCompare(
          b.answers_summary.find((x: { name: string; }) => x.name.toLocaleLowerCase().includes("vehicle reg"))?.answer)
      } else {
        return 0
      }
    }
    )
  }

  checkIfHasWaste(booking: any) {
    if (this.config.wasteLimits?.haveWasteQuestion) {
      console.log(booking)
      const test = booking.answers_summary.filter((x: { question_id: { toString: () => any; }; }) => {
        return x.question_id.toString() === this.config.wasteLimits?.haveWasteQuestion.toString()
      });
      console.log(test);
      if (test.length > 0) {
        return test[0].answer;
      }
    }
    return false
  }

  async updateStatus(bookingDetails: any, status: string, event: Event) {
    status = this.commonFunctionsService.statusConverterMulti(status)
    console.log(bookingDetails)
    // DO NOT AWAIT THIS CALL
    this.apiService.updateStatus(bookingDetails.booking.company_id, bookingDetails.booking.id, status)
    console.log(bookingDetails.booking?.settings)
    console.log(status)
    if (bookingDetails.booking?.settings) {
      bookingDetails.booking.settings.current_multi_stat = status
    } else {
      bookingDetails.booking.settings = { "current_multi_stat": status }
    }
    if (status === "") {
      bookingDetails.booking.multi_stats = {}
    }
    bookingDetails.booking.current_multi_status = status
    this.commonFunctionsService.updateLocalBookingsCache(bookingDetails.booking)
    this.refresh(false)
    this.searchText = '';
  }

  changeNoteShowStatus(booking: any, event: Event) {
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    // this.hideAllOpenButtons(parent!, 'notes-open');
    if (booking.showNote) {
      if (parent) {
        parent.classList.remove('notes-open');
      }
      booking.showNote = false
    } else {
      if (parent) {
        parent.classList.add('notes-open');
      }
      booking.showNote = true
      booking.amendQuestionsShow = false
      booking.showQuestionsRO = false
      booking.checkListShow = false
      booking.showAttachments = false
      booking.choicesShow = false
    }
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  changeQuestionROShowStatus(booking: any, event: Event) {
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    // this.hideAllOpenButtons(parent!, 'info-open');
    // if (booking.showQuestionsRO) {
    //   booking.showQuestionsRO = false
    //   if (parent) {
    //     parent.classList.remove('info-open');
    //   }
    // } else {
    if (parent) {
      parent.classList.add('info-open');
    }
    booking.showQuestionsRO = true
    booking.amendQuestionsShow = false
    booking.showNote = false
    booking.checkListShow = false
    booking.showAttachments = false
    booking.choicesShow = false
    booking.checkList = false
    booking.uploadShow = false
    const config = this.fetchConfig();
    this.readonlyQuestionsContents =
    config?.ceremony_officer_app?.customizable?.confirmed?.buttons?.readOnlyQuestions?.contents || [];

    console.log('readonlyQuestionsContents:', this.readonlyQuestionsContents);
    console.log('Setting bookingDetails:', booking);
    this.bookingDetails = booking;
    this.prepareTableData();
    console.log('Prepared table data:', this.preparedTableData);

    console.log(booking.showQuestionsRO)
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  toggleCheckList(bookingDetails: any, event: Event) {
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    console.log("bd", bookingDetails)
    console.log("bd", bookingDetails.amendQuestionsShow)
    // this.hideAllOpenButtons(parent!, '');
    // if (bookingDetails.amendQuestionsShow) {
    //   bookingDetails.checkListShow = false
    // } else {
    bookingDetails.checkListShow = true
    bookingDetails.amendQuestionsShow = false
    bookingDetails.showQuestionsRO = false
    bookingDetails.showNote = false
    bookingDetails.uploadShow = false
    bookingDetails.showAttachments = false
    bookingDetails.choicesShow = false
    bookingDetails.checkList = false
    this.onQuestionChange(bookingDetails.bookingQuestionsForm, bookingDetails)
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  toggleAmendQuestionsShow(bookingDetails: any, event: Event) {
    console.log("honk!")
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    console.log("bd", bookingDetails)
    console.log("bd", bookingDetails.amendQuestionsShow)
    // this.hideAllOpenButtons(parent!, '');
    // if (bookingDetails.amendQuestionsShow) {
    //   bookingDetails.amendQuestionsShow = false
    // } else {
    // Re-add this block if you want to toggle tabs on and off
    bookingDetails.amendQuestionsShow = true
    bookingDetails.checkListShow = false
    bookingDetails.showQuestionsRO = false
    bookingDetails.showNote = false
    bookingDetails.uploadShow = false
    bookingDetails.showAttachments = false
    bookingDetails.choicesShow = false
    this.onQuestionChange(bookingDetails.bookingQuestionsForm, bookingDetails)
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  changeUploadStatus(bookingDetails: any, event: Event) {
    console.log(bookingDetails)
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    console.log(bookingDetails)
    // this.hideAllOpenButtons(parent!, '');
    // if (bookingDetails.uploadShow) {
    //   bookingDetails.uploadShow = false
    // } else {
    // Re-add this block if you want to toggle tabs on and off
    bookingDetails.uploadShow = true
    bookingDetails.checkListShow = false
    bookingDetails.amendQuestionsShow = false
    bookingDetails.showQuestionsRO = false
    bookingDetails.showNote = false
    bookingDetails.showAttachments = false
    bookingDetails.choicesShow = false
    bookingDetails.checkList = false
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  async changeAttachmentsStatus(bookingDetails: any, event: Event) {
    console.log(bookingDetails)
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    console.log(bookingDetails)
    // // this.hideAllOpenButtons(parent!, '');
    // if (bookingDetails.showAttachments) {
    //   bookingDetails.showAttachments = false
    // } else {
    // Re-add this block if you want to toggle tabs on and off
    this.bookingFiles = await this.apiService.jrniReadFiles(bookingDetails.booking.company_id, bookingDetails.booking.purchase_ref, bookingDetails.booking.id)
    console.log(this.bookingFiles)
    bookingDetails.showAttachments = true
    bookingDetails.checkListShow = false
    bookingDetails.amendQuestionsShow = false
    bookingDetails.showQuestionsRO = false
    bookingDetails.showNote = false
    bookingDetails.uploadShow = false
    bookingDetails.choicesShow = false
    bookingDetails.checkList = false
    this.virtualScroller.invalidateAllCachedMeasurements();
  }

  async changeChoicesStatus(bookingDetails: any, event: Event) {

    console.log(bookingDetails);
    const target = event.target as HTMLInputElement;
    const parent: HTMLElement | null = target.closest('.scroll-item');
    console.log(bookingDetails);

    // this.hideAllOpenButtons(parent!, '');
    // if (bookingDetails.choicesShow) {
    //   bookingDetails.choicesShow = false
    // } else {

    this.spinner.show();

    const metaResult: any = await this.apiService.getMetadataForBooking(
      bookingDetails.booking.company_id,
      bookingDetails.booking.id,
      'ceremony_choices'
    );

    const schemaResult = await this.apiService.getFormSchema(
      'ceremony_choices_' + this.dataStore.services[bookingDetails.booking.service_id].global_id
    ) as { schema: { fields: any[] }};


    console.log(schemaResult);

    if (metaResult.Item) {
      this.meta = metaResult.Item.data;
    } else {
      this.meta = [];

      console.log(bookingDetails)
      const target = event.target as HTMLInputElement;
      const parent: HTMLElement | null = target.closest('.scroll-item');
      console.log(bookingDetails)
      this.hideAllOpenButtons(parent!, '');
    }

      // this.bookingFiles = await this.apiService.jrniReadFiles(bookingDetails.booking.company_id, bookingDetails.booking.purchase_ref, bookingDetails.booking.id)
      // this.spinner.show()
      // const metaResult: any = await this.apiService.getMetadataForBooking(bookingDetails.booking.company_id, bookingDetails.booking.id, 'ceremony_choices');
      // this.schema = await this.apiService.getFormSchema('ceremony_choices_' + this.dataStore.services[bookingDetails.booking.service_id].global_id);
      // console.log("this.schema", this.schema)
      // console.log("metaResult", metaResult2)
      // if (metaResult.Item) {
      //   this.meta = metaResult.Item.data
      // } else {
      //   this.meta = []
      // }
      this.schema = schemaResult.schema.fields
      for (let question of this.schema) {
        question.onBlacklist = this.inChoicesBlacklistList(question.field)
        question.visible = this.schemaQuestionVisible(question.field)
      }
      console.log(this.meta)
      console.log(this.schema)
      // for (let question of this.schema) {
      //   question.title = question.title.replace("<h2>", "")
      //   question.title = question.title.replace("</h2>", "")
      // }
      // console.log(this.bookingFiles)
      bookingDetails.choicesShow = true
      bookingDetails.checkListShow = false
      bookingDetails.amendQuestionsShow = false
      bookingDetails.showQuestionsRO = false
      bookingDetails.showNote = false
      bookingDetails.uploadShow = false
      bookingDetails.showAttachments = false
      this.bookingDetails = bookingDetails;
      console.log(bookingDetails)
      console.log(bookingDetails.choicesShow)
      this.spinner.hide()
      // }
      this.virtualScroller.invalidateAllCachedMeasurements();

      this.bookingDetails = bookingDetails;

      console.log(bookingDetails);
      console.log(bookingDetails.choicesShow);

      this.spinner.hide();

    this.virtualScroller.invalidateAllCachedMeasurements();
  }


  handleButtonClick(key: string, bookingDetails: any, event: Event): void {
    switch (key) {
      case 'upload':
        this.changeUploadStatus(bookingDetails, event);
        break;
      case 'choices':
        this.changeChoicesStatus(bookingDetails, event);
        break;
      case 'amend':
        this.toggleAmendQuestionsShow(bookingDetails, event);
        break;
      case 'checklist':
        this.toggleCheckList(bookingDetails, event);
        break;
      case 'attachments':
        this.changeAttachmentsStatus(bookingDetails, event);
        break;
      default:
        console.warn(`No handler defined for button key: ${key}`);
    }
  }


  hideAllOpenButtons(parent: HTMLElement, except: string) {
    switch (except) {
      case 'info-open':
        parent.classList.remove('notes-open');
        break;
      case 'notes-open':
        parent.classList.remove('info-open');
        break;
      default:
        parent.classList.remove('notes-open');
        parent.classList.remove('info-open');
    }
  }

  findAnswer(question: string) {
    const answer = this.meta.find((x: { field: string; }) => x.field === question)
    if (answer) {
      if (answer.value && answer.value !== "") {
        const questionSchema = this.schema.find((x: { field: string; }) => x.field === question)
        if (questionSchema.options) {
          const option = questionSchema.options.find((x: { value: any; }) => x.value === answer.value)
          return option.title
        } else if (questionSchema.radio_options) {
          const option = questionSchema.radio_options.find((x: { value: any; }) => x.value === answer.value)
          if (option) {
            return option?.title
          } else {
            return answer.value
          }
        } else if (questionSchema.type === 'upload') {
          let fileList = ""
          for (let i in answer.value) {
            const file = answer.value[i].file.name
            fileList += file
            if (parseInt(i) !== answer.value.length - 1) {
              fileList += ", "
            }
            return fileList
          }
        } else {
          return answer.value
        }
      }
    }
    return "-"
  }

  schemaQuestionVisible(question: string) {
    const questionSchemaBase = this.schema.find((x: { field: string; }) => x.field === question)
    if (questionSchemaBase.trigger) {
      const questionTriggerArray = questionSchemaBase.trigger.split("|")
      const questionTriggerValueArray = questionSchemaBase.trigger_value.split("|")
      for (let i in questionTriggerArray) {
        const answer = this.meta.find((x: { field: string; }) => x.field === questionTriggerArray[i])

        // if (answer.value.toString() === questionTriggerValueArray[i].toString()) {
        //   return true
        // }

        if (answer) {
          answer.schemaField = this.schema.find((x: { field: string; }) => x.field === questionTriggerArray[i])

          if (this.schemaQuestionVisible(answer.field)) {
            if (answer.value.toString() === questionTriggerValueArray[i].toString()) {
              return true
            } else {
              let option = undefined
              if (answer.schemaField) {
                if (answer.schemaField.options) {
                  option = answer.schemaField.options.find((x: { value: any; }) => x.value === questionTriggerValueArray[i].toString())
                } else if (answer.schemaField.radio_options) {
                  option = answer.schemaField.radio_options.find((x: { value: any; }) => {
                    return x.value === questionTriggerValueArray[i].toString()
                  })
                }
              }
              if (option) {
                if (option.title.toString() === answer.value.toString()) {
                  return true
                }
              }
            }
          }
        }
      }
      return false
    } else {
      return true
    }
  }

  print() {
    const doc = document.getElementById('bookingQuestions');
    let popupWin;
    if (doc) {
      const headerHTML = `
      <div class="print-header">
        <p>Party 1 name: ${this.bookingDetails.booking.questions['34272'].answer} ${this.bookingDetails.booking.questions['34273'].answer}</p>
        <p>Party 2 name: ${this.bookingDetails.booking.questions['34286'].answer} ${this.bookingDetails.booking.questions['34287'].answer}</p>
        <p>Ceremony Venue: ${this.bookingDetails.booking.resource_name}</p>
        <p>Ceremony time: ${this.bookingDetails.booking.datetime}</p>
      </div>
    `;

      const printContents = headerHTML + doc.innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      if (popupWin) {
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Print tab</title>
              <style>
                .print-header { margin-bottom: 20px; }
              </style>
            </head>
        <body onload="window.print();window.close()">${printContents}</body>
          </html>`
        );
        popupWin.document.close();
      }
    }
  }

  fileSizeCalc(file_size: number) {
    return Math.round(file_size / 1024)
  }

  async deleteFile(bookingDetails: any, file: any) {
    this.spinner.show()
    await this.apiService.jrniDeleteFile(bookingDetails.booking.company_id, bookingDetails.booking.purchase_ref, bookingDetails.booking.id, file.uuid)
    this.bookingFiles = await this.apiService.jrniReadFiles(bookingDetails.booking.company_id, bookingDetails.booking.purchase_ref, bookingDetails.booking.id)
    this.spinner.hide()
  }

  showNotesDropdown() {
    if (this.config?.set?.notesDropDown?.show) {
      return true
    }
    else {
      return false
    }
  }


  uploadTest(bookingDetails: any, event: Event) {
    console.log(event);
    this.fileError = false

    const target: HTMLInputElement = (event.target as HTMLInputElement);
    for (const file of Array.from(target.files!)) {
      console.log("filesize:", file.size / 1024 / 1024, " MB")
      if (file.size <= 10485760) {
        const formData = new FormData();
        formData.append("file", file);
        this.fileData = formData
        this.fileSelector = target
      } else {
        this.fileData = undefined
        this.fileError = true
        target.value = ''
      }
    }
  }

  async saveFile(bookingDetails: any) {
    if (this.fileData) {
      this.apiService.directJrniUpload(this.fetchConfig(), this.fileData, bookingDetails.booking.purchase_ref, bookingDetails.booking.id)
      bookingDetails.uploadShow = false
      this.fileData = undefined
      if (this.fileSelector) this.fileSelector.value = '';
      this.search(bookingDetails.booking.id)
    }
  }

  async addNote(bookingDetails: any) {
    const settings = bookingDetails.settings;
    settings.private_notes = [bookingDetails.note]
    await this.apiService.saveSettings(bookingDetails.booking.company_id, bookingDetails.booking.id, settings)
    if (this.showNotesDropdown()) {
      bookingDetails.booking.questions[this.config.ceremony_officer_app.notesDropDown.adminBookingQuestionID] = {
        answer: bookingDetails.option
      }
      await this.apiService.updateAnswers(bookingDetails.booking.company_id, bookingDetails.booking.id, bookingDetails.booking.questions)
    }
    this.commonFunctionsService.updateLocalBookingsCache(bookingDetails.booking)
    bookingDetails.showNote = false
    // this.getBookings()
  }

  async saveQuestionUpdate(bookingDetails: any) {
    const updatedQuestions: any = {}
    for (let question of bookingDetails.service.bookingQuestions) {
      const questionId = question.id
      if (this.inModifiableQuestionsList(questionId)) {
        let value = bookingDetails.bookingQuestionsForm.value[questionId];
        if (value === undefined || value === null) {// question might be set to no have an answer
          value = ""
        }
        console.log('questionId', questionId, 'questions', bookingDetails.booking.questions);
        let answer = bookingDetails.booking.questions[questionId.toString()];
        if (answer) {
          if (answer.answer_id) {
            const option = question.options.filter((x: { name: string; }) => x.name.toString() === value.toString())[0]
            if (option) {
              answer.answer_id = option.id;
            } else { // question might be set to no have an answer
              answer.answer_id = ""
            }

          }
        } else {
          let newQuestion = {
            answer: value,
            name: question.name
          }
          bookingDetails.booking.questions[question.id] = newQuestion;
          answer = newQuestion
        }
        answer.answer = value;
        updatedQuestions[questionId] = answer
      }
    }
    console.log(updatedQuestions)
    await this.apiService.updateAnswers(bookingDetails.booking.company_id, bookingDetails.booking.id, updatedQuestions)

    this.search(bookingDetails.booking.id)
  }

  async noShowAll() {
    await this.commonFunctionsService.noShowAll(this.bookings)
    this.noShowAllConfirmToggle = false
    // this.getBookings()
  }

  fetchConfig() {
    return JSON.parse(this.dataStore.config)
  }

  async search(searchText: string = "") {

    if (searchText === "") {
      searchText = this.searchText
    }
    this.loadedTable = false
    if (searchText === "") {
      this.bookings = []
    } else {
      console.log(this.fetchConfig())
      const booking: any = await this.apiService.getBooking(this.fetchConfig().company, searchText)
      console.log(booking)
      if (booking) {
        // const service: any = await this.apiService.getService(booking.company_id, booking.service_id)
        // service.bookingQuestions = await this.apiService.questions(service);
        // service.bookingQuestions = service.bookingQuestions.questions
        // const client = await this.apiService.getClient(this.config.company, booking.client_id)
        // console.log(client)
        // const bookings = [{ booking: booking, member: client, service: service }]
        // console.log(bookings)

        this.bookings = await this.makeDetailsArray([booking])
      }

      this.loadedTable = true
    }
  }


  getDataForTable(data: any, tab: any, min = -1, override = null) {
    const keyArray = tab.data
    let out = data;
    if (override) {
      out = override
    }
    let answerArray = false
    for (let i in keyArray) {
      if (parseInt(i) > min) {
        const key = keyArray[i]
        if (out !== undefined) {
          if (key.filterKey) {
            if (!Array.isArray(key.filterValue)) {
              out = out.filter((x: any) => x[key.filterKey].toString() === key.filterValue.toString())[0]
            } else { // we've been given an array of keys to find and combine
              let outConcat = ""
              answerArray = true

              for (let subKey of key.filterValue) {
                const filtered = out.find((x: any) => {
                  return x[key.filterKey].toString() === subKey.toString()
                })
                if (filtered) {
                  outConcat += this.getDataForTable(data, tab, parseInt(i), filtered)
                } else {
                  outConcat += "-"
                }
                if (!tab.separator) {
                  tab.separator = " "
                }
                outConcat += tab.separator

              }
              out = outConcat;
              out = out.substring(0, out.length - tab.separator.length);
              return out
            }
          } else {
            out = out[key]
          }
        }
      }
    }

    if (!answerArray) {
      out = this.outFormat(out, keyArray, tab, data)
    }

    return out;
  }

  outFormat(out: any, keyArray: any, tab: any, data: any) {
    if (out === undefined || out === "" || keyArray.length === 0) {
      out = "-"
    } else {
      if (tab.format === "date") {
        out = moment(out).format("DD MMMM YYYY")
      }
      if (tab.format === "time") {
        out = moment(out).format("HH:mm")
      }
    }

    if (keyArray[1] === "answers_summary" && keyArray[2].filterValue) {

      out = this.convertIfBool(data, keyArray[2].filterValue.toString(), out)
    }

    return out
  }

  convertIfBool(data: any, id: any, out: any) {
    const question = data.service.bookingQuestions.filter((x: any) => {
      return x.id.toString() === id
    })[0]
    if (question) {
      if (question.detail_type === "check") {
        if (out === "1" || out === "true" || out === true) {
          out = "Yes"
        }
        if (out === "0" || out === "false" || out === false || out === "-") {
          out = "No"
        }
      }
    }
    return out;
  }

  checkIfHeading(data: any, tab: any) {
    if (tab) {
      if (tab.data) {
        const keyArray = tab.data

        if (keyArray[1] === "answers_summary") {

          const question = data.service.bookingQuestions.find((x: any) => {
            return x.id.toString() === keyArray[2].filterValue.toString()
          })
          if (question) {
            if (question.detail_type === "heading") {
              return true
            }
          }
        }
      }
    }
    return false
  }

  answerParse(data: any, id: string, out: any) {
    return this.convertIfBool(data, id.toString(), out)
  }

  isJsonString(str: string) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }


  isValidDate(dateString: any) {
    // Attempt to create a Date object from the dateString
    const date = new Date(dateString);

    // Check if the created Date object is valid and its string representation matches the input
    return date instanceof Date && !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === dateString;
  }

  evaluateORCondition(condition: any, answer: any) {
    const parts = condition.split(' OR ');

    let evaluation = [];
    // Evaluate each part of the condition
    for (const part of parts) {
      if (part == answer) {
        evaluation.push(true);
      } else {
        evaluation.push(false);
      }
    }

    let evalArray = evaluation.some(element => element === true);
    // If evaluation has a true, one of the values is correct so it will return true
    return evalArray;
  }

  isValidDateQuestion(dateString: any) {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); // Check if the date is valid
  }

  getEditGroup(bookingQuestion = null) {
    return this.bookingEditQuestions
  }

  onQuestionChange(form: any, bookingDetails: any) {
    const bookingQuestions: any = bookingDetails.service.bookingQuestions;
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {

      const bookingQuestion = bookingQuestions[index];
      if (this.inModifiableQuestionsList(bookingQuestion.id)) {
        bookingQuestion.visible = false; // reset any questions that shouldn't be visible
        // go get the answer for every question from the form
        // set booking question from form values
        // bookingQuestion.answer = control.answer ? control.answer : undefined;

        if (bookingQuestion["help_text"] && this.isJsonString(bookingQuestion["help_text"])) {
          bookingQuestion.conditionals = JSON.parse(bookingQuestion["help_text"]); // to change to settings block soon
          if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
            bookingQuestion.helptext = bookingQuestion.conditionals.help_text;
            let linkPattern = /#(.*?)#/g;
            if (linkPattern.test(bookingQuestion.helptext)) {
              bookingQuestion.helptext = bookingQuestion.helptext.replace(linkPattern, function (match: any, p1: any) {
                return `<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` + p1 + '</a>';
              });
            }
          }
          if (bookingQuestion.conditionals.hasOwnProperty('question-font-colour')) {
            bookingQuestion.customLabelColour = bookingQuestion.conditionals['question-font-colour'];
          }
          if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
            if (bookingQuestion.conditionals['address_lookup'] === 'yes' || bookingQuestion.conditionals['address_lookup'] === 'true') {
              bookingQuestion.address_lookup = true
            }
          }
          if (bookingQuestion.conditionals.hasOwnProperty('resource_lookup')) {
            if (bookingQuestion.conditionals['resource_lookup'] === 'yes' || bookingQuestion.conditionals['resource_lookup'] === 'true') {
              bookingQuestion.resource_lookup = true;
              bookingQuestion.selected_resource = undefined;
            }
          }
          if (bookingQuestion.conditionals.hasOwnProperty('company_and_resource_set')) {
            if (bookingQuestion.conditionals['company_and_resource_set'] === 'yes' || bookingQuestion.conditionals['company_and_resource_set'] === 'true') {
              bookingQuestion.company_and_resource_set = true;
            }
          }

          // if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
          //   if (bookingQuestion.conditionals.section_title) {
          //     bookingQuestion.detail_type = "heading_2";
          //   }
          // }


          let conditionals = bookingQuestion.conditionals;
          let show = conditionals.show //|| ;
          // console.log(conditionals.admin_show)
          let hide = conditionals.hide;
          let admin_show = conditionals.admin_show;
          let admin_only = conditionals.admin_only;
          let custom = conditionals.custom;

          // if the booking is only for the admin journey

          if (Object.keys(show).length === 0 && Object.keys(hide).length === 0 && !conditionals.admin_only) {
            // no hide or show conditional values, just show the question by default
            bookingQuestion.visible = true;
          }
          console.log("conditionals.show", conditionals.show)

          // show condition loop
          for (const answerId in show) {
            if (answerId == 'hide') {
              return; // this shouldnt happen only if the setup is wrong
            }
            if (answerId == 'custom') {
              // custom conditionals to go here
              let conditionalQuestion = bookingQuestions.find((x: any) => x.id.toString() === `${Object.keys(show[answerId])[0]}`)
              conditionalQuestion.answer = form.controls[conditionalQuestion.id].value;
              if (conditionalQuestion && conditionalQuestion.answer != null) {
                if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) {
                  let condition: any = Object.values(show[answerId])[0];
                  if (condition.includes('OR')) {
                    if (this.evaluateORCondition(condition, conditionalQuestion.answer)) {
                      bookingQuestion.visible = true;
                    }
                  } else {
                    // if (this.evaluateCondition(condition, conditionalQuestion.answer)) {
                    //   bookingQuestion.visible = true;
                    // }
                  }
                }
              }
            } else {
              // if this is an admin journey, and there is an admin show value
              let conditionalQuestion = bookingQuestions.find((x: any) => x.id.toString() === `${Object.keys(show[answerId])[0]}`)
              conditionalQuestion.answer = form.controls[conditionalQuestion.id].value;
              console.log(conditionalQuestion)
              if (conditionalQuestion && conditionalQuestion.answer != null) {
                if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) {
                  if (show[answerId].trim() == "*") { // wild card
                    if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) { // if there is any answer
                      bookingQuestion.visible = true;
                    }
                  } else {
                    if (`${conditionalQuestion.answer}` == `${show[answerId]}`) {
                      bookingQuestion.visible = true;
                    }
                  }
                }
              }
            }
          }

          // perform hide after show because we want it to take priority
          for (const answerId in hide) {
            if (answerId == 'show') {
              return; // this shouldnt happen only if the setup is wrong
            }
            if (answerId == 'custom') {
              let conditionalQuestion = bookingQuestions.find((x: any) => x.id.toString() === `${Object.keys(show[answerId])[0]}`)
              conditionalQuestion.answer = form.controls[conditionalQuestion.id].value;
              if (conditionalQuestion && conditionalQuestion.answer != null) {
                if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) {
                  let condition: any = Object.values(hide[answerId])[0];
                  if (condition.includes('OR')) {
                    if (this.evaluateORCondition(condition, conditionalQuestion.answer)) {
                      bookingQuestion.visible = true;
                    }
                  } else {
                    // if (this.evaluateCondition(condition, conditionalQuestion.answer)) {
                    //   bookingQuestion.visible = true;
                    // }
                  }
                }
              }
            } else {
              let conditionalQuestion = bookingQuestions.find((x: any) => x.id.toString() === `${Object.keys(show[answerId])[0]}`)
              conditionalQuestion.answer = form.controls[conditionalQuestion.id].value;
              if (conditionalQuestion && conditionalQuestion.answer != null) {
                if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) {
                  if (show[answerId] == "*") { // wild card
                    if ((conditionalQuestion.answer || conditionalQuestion.answer.length > 0)) { // if there is any answer
                      bookingQuestion.visible = true;
                    }
                  } else {
                    if (`${conditionalQuestion.answer}` == `${show[answerId]}`) {
                      bookingQuestion.visible = false;
                    }
                  }
                }
              }
            }
          }

          // add hidden field
          if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
            bookingQuestion.hidden = true;
          }

          // add duration schema 
          // if (bookingQuestion.visible) {
          //   if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
          //     this.datastoreService.extraDuration = (Number(this.datastoreService.extraDuration) + Number(bookingQuestion.conditionals.add_duration));
          //   }
          // }

          if (!bookingQuestion.visible) {
            form.controls[bookingQuestion.id].setValue("");
            form.controls[bookingQuestion.id].disable();
          }
        } else {
          bookingQuestion.visible = true;
        }
      }
    }
  }


  keyPressNumberField(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  inModifiableQuestionsList(id: string) {
    return this.fetchConfig().ceremony_officer_app.customizable.confirmed.buttons.amend.whitelist.filter((x: any) => x.toString() === id.toString()).length > 0
  }

  inChoicesBlacklistList(field: string) {
    return this.fetchConfig().ceremony_officer_app.customizable.confirmed.buttons.choices.blacklist.filter((x: any) => x.toString() === field.toString()).length > 0
  }

  regObserved(data: any, tabs: any) {
    if (this.observed) {
      const tab = tabs.find((x: { heading: string; }) => x.heading === "Vehicle Reg")
      const reg = this.getDataForTable(data, tab)
      if (reg) {
        const observedEntry = this.observed.registrations.find((x: { regno: any; }) => x.regno === reg)
        if (observedEntry) {
          if (observedEntry.reason) {
            return observedEntry.reason
          }
        }
      }
    }
    return false
  }

  notesTextField() {
    if (this.config.ceremony_officer_app.set.notesTextField !== undefined && this.config.ceremony_officer_app.set.notesTextField !== null) {
      if (this.config.ceremony_officer_app.set.notesTextField.show !== undefined && this.config.ceremony_officer_app.set.notesTextField.show !== null) {
        return this.config.ceremony_officer_app.set.notesTextField.show
      }
    }
    return true
  }
}

